import { NgModule } from '@angular/core';
import { TranslatePipe } from '../pipe/translate.pipe';
import { TranslateDirective } from '../directives/translate/translate.directive';
import { CommonModule } from '@angular/common';
import { TranslateService } from 'app/services/translate/translate.service';

@NgModule({
    imports: [CommonModule],
    exports: [TranslatePipe, TranslateDirective],
    declarations: [TranslatePipe, TranslateDirective],
    providers: [
        TranslateService,
    ],
})
export class TranslateModule {}
